import { collectStatusMatchApplicationFields } from "../utils/status_match_form"

export const screenCaptureSession = {
  async openValidationPage(event) {
    if (event) event.preventDefault()
    this.hideInterruptionNotice()

    if (!this.screenShareApiAvailable()) {
      return this.setStatus(
        this.t("unavailable", "Screen sharing is not available in this browser. Use Chrome, Edge, or Firefox on a computer."),
        "error"
      )
    }

    if (!this.session) {
      const ok = await this.ensureSession()
      if (!ok) {
        return this.setStatus(this.t("session_error", "Could not start a verification session. Reload and try again."), "error")
      }
    }

    const url = `/validations/${encodeURIComponent(this.session.id)}`
    try {
      if (this.validationWindow && !this.validationWindow.closed) {
        this.validationWindow.focus()
      } else {
        this.validationWindow = window.open(url, "statsync_validation")
      }
    } catch {
      this.validationWindow = null
    }

    if (!this.validationWindow) {
      return this.setStatus(
        this.t("popup_blocked", "Your browser blocked the verification tab. Allow pop-ups, then try again."),
        "error"
      )
    }

    this.markSubstepOpenDone()
    this.setStatus(this.t("tab_opened", "Verification tab opened. Now start screen sharing and pick that tab."), "info")
  },

  async ensureSession() {
    if (!this.wizardModeValue || !this.sessionsUrlValue) return false
    if (this.session) return true

    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      const body = {
        status_match_campaign_id: this.campaignIdFromForm(),
        status_match_application: this.collectApplicationFields()
      }
      const response = await fetch(this.sessionsUrlValue, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": token },
        body: JSON.stringify(body)
      })
      const data = await response.json().catch(() => ({}))
      if (!response.ok || !data?.ok) return false
      this.session = { id: data.session_id }
      // The submission is attributed to this session: the server reads the verdict
      // it recorded per frame rather than anything posted from here.
      if (this.hasHiddenSessionIdTarget) this.hiddenSessionIdTarget.value = data.session_id || ""
      return true
    } catch {
      return false
    }
  },

  campaignIdFromForm() {
    return (
      this.element.closest("form")
        ?.querySelector('[name="status_match_application[status_match_campaign_id]"]')
        ?.value ||
      this.campaignIdValue ||
      ""
    )
  },

  collectApplicationFields() {
    return collectStatusMatchApplicationFields(this.element.closest("form"))
  },

  async attachUsefulFrameToForm(dataUrl) {
    const input = this.element.closest("form")
      ?.querySelector('input[type="file"][name="status_match_application[supporting_documents][]"]')
    if (!input) return

    try {
      const blob = await (await fetch(dataUrl)).blob()
      const file = new File([blob], `screen-capture-capture-${Date.now()}.jpg`, { type: "image/jpeg" })
      this.verifiedWizardFiles = [...this.verifiedWizardFiles, file].slice(-this.evidenceLimitValue)
      const transfer = new DataTransfer()
      this.verifiedWizardFiles.forEach((verifiedFile) => transfer.items.add(verifiedFile))
      input.files = transfer.files
      input.dispatchEvent(new Event("change", { bubbles: true }))
    } catch {
      // Evidence attachment is best-effort; the analyzed server result remains authoritative.
    }
  }
}
